import * as Scrivito from "scrivito";
import { useNavigation } from "^/Context/NavigationContext";

function MainNavigationLink({ child }) {
  const { open, setOpen, setActiveItem, setActiveMainItem, activeMainItem } =
    useNavigation();

  if (!child) {
    return null;
  }

  const firstChild = async (curChild) => {
    const childrenOrdered = await Scrivito.load(() =>
      curChild.get("childOrder")
    );
    const children = await Scrivito.load(() => curChild.children());
    const allChilds = [...childrenOrdered, ...children];
    const filtered = allChilds.filter(
      (c) => c.get("hideInNavigation") !== "yes"
    );
    return filtered[0];
  };

  return (
    <Scrivito.LinkTag
      className="text-dark"
      onClick={async () => {
        const first = await firstChild(child);
        if (!first && child) {
          // There is no active child element, navigate to the item
          setOpen(false);
          setActiveMainItem(null);
          setActiveItem(null);
          Scrivito.navigateTo(child);
        } else if (open && activeMainItem?.id() === child.id()) {
          // There is an active child element and the Navigation is open, close it
          setOpen(false);
          setActiveMainItem(null);
          setActiveItem(null);
        } else {
          // There is an active child element but the Navigation is closed, open it
          setOpen(true);
          setActiveMainItem(child);
          setActiveItem(first);
        }
      }}
    >
      {child.get("title")}
    </Scrivito.LinkTag>
  );
}

export default Scrivito.connect(MainNavigationLink);
